import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {Box, keyframes} from "@mui/material";

export default function ProjectCard({imgPath, title, description, ctaUrl, skills}) {

    const rotateSkill = keyframes`
        0% { transform: rotate(-2deg); }
        100% { transform: rotate(2deg); }
    `;

    const skillSx = {
        fontSize: "13px",
        padding: "4px 8px",
        backgroundColor: "#f5f5f5",
        textTransform: "uppercase",
        animation: `${rotateSkill} 2.0s linear infinite alternate`,
        margin: "10px",
        width: 'fit-content',
        height: 'fit-content',
        borderRadius: '4px',
        fontStyle: 'italic'
    }

    const onCtaClick = () => {
        window.open(ctaUrl, '_blank', 'noopener,noreferrer');
    }

    return (
        <Card sx={{
            maxWidth: 345,
            height: '100%',
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
        }}>
            <Box sx={{
                justifyContent: 'start',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <CardMedia
                    component="img"
                    alt={title}
                    height="140"
                    image={imgPath}
                    sx={{ objectFit: "contain", marginTop: '16px' }} // Ensures the full image is shown
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div" fontWeight={'bold'} textAlign={'center'}>
                        {title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', paddingBottom: '16px' }} textAlign={'center'}>
                        {description}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', minHeight: '230px', justifyContent: 'center', alignContent: 'baseline'}}>
                        {skills.map((skill) => (<Typography variant="body2" component={'div'} sx={skillSx}>
                            {skill}
                        </Typography>))}
                    </Box>
                </CardContent>
            </Box>
            <CardActions sx={{display: 'flex', justifyContent: 'center', paddingBottom: '16px'}}>
                <Button size="small" variant={'outlined'} onClick={onCtaClick} disabled={!ctaUrl} sx={{flexBasis: '90%'}}>
                    {ctaUrl ? 'Check it out' : 'No Longer Available'}
                </Button>
            </CardActions>
        </Card>
    );
}